import React from "react";
import { JsonViewer } from '@textea/json-viewer';

const JSONView = ({ gameObject }) => {
  return (
    <JsonViewer 
      value={gameObject} 
      theme="light" // or 'light'
      displayDataTypes={false} // cleaner display
      enableClipboard={true} // allows copying values
      rootName={false} // hides the root name
    />
  );
};

export default JSONView;
